import React from 'react';

import Logo from '../../logo';

import './sidebar-header.scss';

interface SidebarHeaderProps {
  sm?: boolean;
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({ sm }) => (
  <div className="sidebar__header">
    <Logo />

    <p className="logo__text">Цифровые финансовые активы</p>
  </div>
);

export default SidebarHeader;
